module.exports = __webpack_public_path__ + "697be3b5bfac6bf6f0ef2ed9a1ab42ad.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/MA.svg
// module id = gCNj
// module chunks = 0